import React, { useState, useCallback } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';

import PasswordField from 'Dashboard/components/PasswordField/PasswordField';
import OnboardingFormWrapper from '../OnboardingFormWrapper/OnboardingFormWrapper';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

function UserInvitationEdit() {
  const location = useLocation();
  const query = queryString.parse(location.search);
  const invitationTokenFromUrl = query.invitation_token;
  const {
    app: {
      invitationToken: invitationTokenFromApp,
      routes: { userInvitePath },
    },
  } = useApp();

  // During initial load we get the token through the query params, if we reload the page
  // because of a form validation error then we must pass it in through the app state.
  const invitationToken = invitationTokenFromUrl || invitationTokenFromApp;

  const [formValues, setFormValues] = useState({
    'user[password]': '',
    'user[password_confirmation]': '',
  });

  const handleFormValuesChange = useCallback(
    event => setFormValues({ ...formValues, [event.target.name]: event.target.value }),
    [formValues]
  );

  return (
    <OnboardingFormWrapper title="Set your Password" actionPath={userInvitePath} submitText="Set Password">
      <input type="hidden" name="_method" value="put" />
      <PasswordField
        name="user[password]"
        label="Password"
        placeholder="Enter password"
        value={formValues['user[password]']}
        onChange={handleFormValuesChange}
      />
      <PasswordField
        name="user[password_confirmation]"
        label="Password confirmation"
        placeholder="Enter confirm password"
        value={formValues['user[password_confirmation]']}
        onChange={handleFormValuesChange}
      />
      <input type="hidden" name="user[invitation_token]" value={invitationToken} />
    </OnboardingFormWrapper>
  );
}

export default UserInvitationEdit;
